import React from 'react';
import './LegalPages.css';

const Credits = () => {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Crédits</h1>
        
        <section>
          <h2>Développement</h2>
          <p>
            SoundNest est développé avec passion en utilisant des technologies 
            web modernes et des bibliothèques open source.
          </p>
        </section>

        <section>
          <h2>Technologies principales</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <h3>React</h3>
              <p><strong>Version :</strong> 19.1.0</p>
              <p><strong>Licence :</strong> MIT</p>
              <p><strong>Description :</strong> Framework JavaScript pour la construction d'interfaces utilisateur</p>
              <p><strong>Site :</strong> <a href="https://reactjs.org" target="_blank" rel="noopener noreferrer">reactjs.org</a></p>
            </div>

            <div className="tech-item">
              <h3>React DOM</h3>
              <p><strong>Version :</strong> 19.1.0</p>
              <p><strong>Licence :</strong> MIT</p>
              <p><strong>Description :</strong> Rendu React pour le DOM web</p>
            </div>

            <div className="tech-item">
              <h3>React Scripts</h3>
              <p><strong>Version :</strong> 5.0.1</p>
              <p><strong>Licence :</strong> MIT</p>
              <p><strong>Description :</strong> Scripts et configuration pour Create React App</p>
            </div>
          </div>
        </section>

        <section>
          <h2>Bibliothèques d'interface</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <h3>React Icons</h3>
              <p><strong>Version :</strong> 5.5.0</p>
              <p><strong>Licence :</strong> MIT</p>
              <p><strong>Description :</strong> Collection d'icônes populaires pour React</p>
              <p><strong>Site :</strong> <a href="https://react-icons.github.io/react-icons/" target="_blank" rel="noopener noreferrer">react-icons.github.io</a></p>
            </div>
          </div>
        </section>

        <section>
          <h2>Outils de développement</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <h3>Web Vitals</h3>
              <p><strong>Version :</strong> 5.0.3</p>
              <p><strong>Licence :</strong> Apache-2.0</p>
              <p><strong>Description :</strong> Mesure des métriques de performance web</p>
            </div>

            <div className="tech-item">
              <h3>Testing Library</h3>
              <p><strong>Versions :</strong> Multiples</p>
              <p><strong>Licence :</strong> MIT</p>
              <p><strong>Description :</strong> Outils de test pour applications React</p>
              <p><strong>Composants :</strong> @testing-library/react, @testing-library/jest-dom, @testing-library/user-event</p>
            </div>
          </div>
        </section>

        <section>
          <h2>Services externes</h2>
          <div className="service-item">
            <h3>LaSonotheque.org</h3>
            <p>
              <strong>Tous les contenus audio disponibles sur SoundNest proviennent de LaSonotheque.org.</strong>
            </p>
            <p>
              LaSonotheque.org est une plateforme française qui propose des sons libres de droits 
              sous diverses licences Creative Commons. Nous remercions chaleureusement cette 
              communauté pour la mise à disposition de ces ressources de qualité.
            </p>
            <p>
              <strong>Site :</strong> <a href="https://lasonotheque.org" target="_blank" rel="noopener noreferrer">lasonotheque.org</a>
            </p>
            <p>
              <strong>Licences :</strong> Les sons sont généralement sous licence Creative Commons 
              (CC BY, CC BY-SA, CC0, etc.). Chaque son conserve sa licence d'origine telle que 
              définie sur LaSonotheque.org.
            </p>
          </div>
        </section>

        <section>
          <h2>Design et UX</h2>
          <p>
            L'interface de SoundNest a été conçue avec les principes suivants :
          </p>
          <ul>
            <li><strong>Accessibilité :</strong> Interface utilisable par tous</li>
            <li><strong>Responsive Design :</strong> Adaptation à tous les écrans</li>
            <li><strong>Performance :</strong> Chargement rapide et interactions fluides</li>
            <li><strong>Simplicité :</strong> Navigation intuitive et claire</li>
          </ul>
        </section>

        <section>
          <h2>Hébergement et déploiement</h2>
          <p>
            SoundNest utilise des services d'hébergement modernes pour garantir :
          </p>
          <ul>
            <li>Disponibilité élevée (99.9% uptime)</li>
            <li>Chargement rapide via CDN global</li>
            <li>Sécurité HTTPS par défaut</li>
            <li>Déploiement automatisé</li>
          </ul>
        </section>

        <section>
          <h2>Licences open source</h2>
          <p>
            Toutes les bibliothèques utilisées dans ce projet sont sous licence open source, 
            principalement MIT et Apache-2.0. Ces licences permettent l'utilisation libre 
            du code à des fins commerciales et non commerciales.
          </p>
          <p>
            Le respect de ces licences est important pour nous. Si vous remarquez une 
            attribution manquante ou incorrecte, n'hésitez pas à nous le signaler.
          </p>
        </section>

        <section>
          <h2>Contributions et remerciements</h2>
          <p>
            Nous remercions :
          </p>
          <ul>
            <li>La communauté <strong>React</strong> pour cet excellent framework</li>
            <li>Les contributeurs de toutes les bibliothèques open source utilisées</li>
            <li><strong>LaSonotheque.org</strong> pour la mise à disposition des contenus audio</li>
            <li>La communauté des développeurs web pour le partage de connaissances</li>
            <li>Les utilisateurs de SoundNest pour leurs retours et suggestions</li>
          </ul>
        </section>

        <section>
          <h2>Code source</h2>
          <p>
            SoundNest est développé dans un esprit d'ouverture et de transparence. 
            Le code source respecte les bonnes pratiques de développement moderne :
          </p>
          <ul>
            <li>Code modulaire et réutilisable</li>
            <li>Composants React fonctionnels avec hooks</li>
            <li>CSS moderne avec variables personnalisées</li>
            <li>Optimisations de performance</li>
            <li>Accessibilité web (WCAG)</li>
          </ul>
        </section>

        <p className="last-updated">
          <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
        </p>
      </div>
    </div>
  );
};

export default Credits;
